<template>
  <v-app id="inspire">
    <v-main>
      <v-container
        class="fill-height"
        fluid
      >
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            sm="8"
            md="4"
          >
            <v-card class="elevation-12">
              <v-toolbar
                color="#7c167d"
                dark
                flat
                
              >
                <v-toolbar-title color="#7c167d">Ingreso</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-text-field
                    color="#7c167d"
                    label="Email"
                    name="email"
                    prepend-icon="mdi-account"
                    type="text"
                    v-model="email"
                  ></v-text-field>

                  <v-text-field
                    color="#7c167d"
                    id="password"
                    label="Password"
                    name="password"
                    prepend-icon="mdi-lock"
                    type="password"
                    v-model="password"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#7c167d" @click="ingresar()" dark >Ingresar</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
  import axios from "axios";
  import {api_url} from '../config/index';
  
  export default {
    data() {
      return {
        email: '',
        password: ''
      }
    },
    methods: {
        async ingresar() {
          await axios.post(`${api_url}/login`,{email: this.email, password: this.password})
            .then((response) => {                 
              let data = response.data;
              console.log(data);
              if (!data.success) {
                this.$swal(
                  'Error!',
                  data.error,
                  'error'
                )
            return;
          }
          sessionStorage.setItem('token', data.token);
          this.$router.push("home");
          }).catch((err) => {
            this.$swal(
                'Error!',
                err,
                'error'
              )
          });            
        }
      }
  }
</script>